function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2227 889",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M292.994,614.851c75.648,0 137.064,61.416 137.064,137.063c-0,75.648 -61.416,137.064 -137.064,137.064c-75.647,-0 -137.063,-61.416 -137.063,-137.064c0,-75.647 61.416,-137.063 137.063,-137.063Zm1640.9,0c75.648,0 137.063,61.416 137.063,137.063c0,75.648 -61.415,137.064 -137.063,137.064c-75.647,-0 -137.063,-61.416 -137.063,-137.064c0,-75.647 61.416,-137.063 137.063,-137.063Zm-1810.74,137.063l-86.251,0c-9.789,0 -19.177,-3.888 -26.098,-10.81c-6.922,-6.922 -10.811,-16.31 -10.811,-26.099l0,-334.65c-0,-19.578 7.777,-38.354 21.621,-52.198c13.844,-13.844 32.62,-21.621 52.198,-21.621l731.791,-0l-0,445.378l-342.781,0c0,-93.734 -76.1,-169.834 -169.835,-169.834c-93.734,-0 -169.834,76.1 -169.834,169.834Zm1640.9,0l-933.008,0l-0,-678.095c-0,-19.578 7.777,-38.354 21.621,-52.198c13.843,-13.844 32.619,-21.621 52.197,-21.621l559.433,0c35.928,-0 70.624,13.102 97.585,36.85l273.614,241.007c21.414,18.862 46.911,32.501 74.487,39.845l234.668,62.5c48.489,12.914 82.232,56.82 82.232,106.999l-0,227.804c-0,20.384 -16.525,36.909 -36.91,36.909l-86.25,0c-0,-93.734 -76.1,-169.834 -169.835,-169.834c-93.734,-0 -169.834,76.1 -169.834,169.834Zm-605.132,-653.467l-187.075,0c-20.385,0 -36.91,16.525 -36.91,36.91l0,134.332c0,20.385 16.525,36.91 36.91,36.91l187.075,-0l0,-208.152Zm73.579,208.152l433.041,-0c4.607,-0 8.732,-2.852 10.359,-7.161c1.627,-4.31 0.417,-9.177 -3.04,-12.221l-182.933,-161.133c-20.22,-17.811 -46.242,-27.637 -73.189,-27.637l-184.238,0l0,208.152Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupTruck);
export default __webpack_public_path__ + "static/media/PickupTruck.7c4b66127fd2e7998f2541ea03ba0a66.svg";
export { ForwardRef as ReactComponent };